import {
    mapState,
    mapActions
} from 'vuex'
import viewName from '../constant.js'
import html2canvas from 'html2canvas'
import appGuideDialog from '@/components/appGuideDialog/appGuideDialog'
import BScroll from 'better-scroll'

import {
    getPayDetail
} from '@/models/pay'
import {
    getLocalConfig
} from '@/utils/session'
export default {
    name: viewName.payResult,
    inject: ['showLoading', 'hideLoading'],
    components: { appGuideDialog },
    data () {
        return {
            order: '',
            show: false,
            img: '',
            coupon_id: '',
            showConpon: false,
            jumpType: 'home' // 跳转小程序页面
        }
    },
    computed: {
        ...mapState({}),
        wechatPage () {
            // 小程序适用商品页面
            return this.order.coupon ? `package/coupon/pages/couponGoodsList/couponGoodsList.html?user_receive_coupon_id=${this.order.coupon.user_receive_coupon_id}&coupon_id=${this.order.coupon.coupon_id}&sstore_id=${this.order.coupon.store_id}&coupon_type=1` : ''
        }
    },
    created () { },
    async activated () {
        this.showLoading()
        this.coupon_id = this.$route.query.coupon_id
        this.order = await getPayDetail({
            order_id: this.$route.query.order_id,
            order_type: this.$route.query.order_type
        })
        console.log(this.order)
        // promot =
        this.setAppClass({
            isAppend: false,
            className: 'bgWhiteColor'
        })

        this.$emit('setHeader', {
            title: '交易完成',
            showLeft: false,
            hasSearch: false,
            showRight: false
        })
        if (this.order.is_lotto || (this.order.coupon && this.order.coupon.length)) {
            this.onShow()
            this.initBS()
        } else {
            this.hideLoading()
        }
    },
    mounted () {

    },
    methods: {
        ...mapActions(['setAppClass']),
        // 跳转到user
        openGuide () {
            this.$refs.appGuideDialog.open()
            // this.$router.push({
            //     name: 'user',
            //     query: {
            //         source: 'pay'
            //     }
            // })
        },
        toHome () {
            let detailRouter = getLocalConfig('GOODSDETAIL')
            this.$router.push({
                path: detailRouter
            })
            // this.$router.push({
            //     name: 'home',
            //     query: {
            //         id: this.order.marketing_id
            //     }
            // })
        },
        // 返回领券页面
        backCouponDetail () {
            this.$router.go(-1)
        },
        onClose () {
            this.show = false
        },
        onShow () {
            this.show = true
            this.$nextTick(() => {
                setTimeout(() => {
                    this.order.is_lotto ? this.getCanvas(this.order.qr_code) : this.hideLoading()
                }, 500)
            })
        },
        /* canvas裁剪 */
        getCanvas (imgUrl) {
            const that = this
            const canEle = this.$refs.canvasMain   // 获取存放截图的包裹的上一级dom对象（原生）
            const width = canEle.offsetWidth // 获取dom宽
            const height = canEle.offsetHeight   // 获取dom高
            const canvas = document.createElement('canvas')  // 创建一个canvas节点
            const scale = 2 // 定义任意放大倍数 支持小数
            const context = canvas.getContext('2d')
            canvas.width = width * scale // 定义canvas 宽度 * 缩放
            canvas.height = height * scale // 定义canvas高度 *缩放
            context.scale(scale, scale)
            const rect = canEle.getBoundingClientRect() // 获取元素相对于视察的偏移量
            context.translate(-rect.left, -rect.top) // 设置context位置，值为相对于视窗的偏移量负值，让图片复位
            const options = {
                useCORS: true, // 【重要】开启跨域配置
                tainttest: true, // 检测每张图片都已经加载完成
                scale: scale, // 添加的scale 参数
                // scale: scaleBy,
                backgroundColor: null, // 避免下载不全
                canvas, // 自定义 canvas
                width: width, // dom 原始宽度
                height: height,
            }
            const imgs = new Image()
            imgs.onload = function () {
                // 截图远程图片的时候会出现跨域，最新版本目前还没好的解决方案，直接拿了相对稳定的版本html2canvas 0.5.0-beta3
                // 解决了跨越，但是如果截图区域有base64图片依然不成功，原因是node包里面对解析的base64后面加了时间戳导致src不能识别，
                // 所以修改了config/templateInlineResources/html2canvas.js包里面1263行代码为
                // if (src.match(/data:image\/.*;base64,/i)) {
                //     self.image.src = src;
                // } else {
                //     self.image.src = src +'?'+ new Date().getTime();
                // }
                html2canvas(canEle, options).then(canvas => {
                    canvas.style.width = width + 'px'
                    canvas.style.height = height + 'px'
                    let dataURL = canvas.toDataURL('image/png')
                    that.img = dataURL
                    // that.firstFlag = false
                    const context = canvas.getContext('2d')
                    // 关闭抗锯齿 保证生成的分享图是清晰的
                    context.mozImageSmoothingEnabled = false
                    context.webkitImageSmoothingEnabled = false
                    context.msImageSmoothingEnabled = false
                    context.imageSmoothingEnabled = false
                    that.hideLoading()
                })
            }
            imgs.onerror = () => {
                // 安卓机canvas.toDataUrl的时候导出的base64图片没有base64前缀 走了 imgs.onerror
                html2canvas(canEle, options).then(canvas => {
                    canvas.style.width = width + 'px'
                    canvas.style.height = height + 'px'
                    let dataURL = canvas.toDataURL('image/png')
                    that.img = dataURL
                    // that.firstFlag = false
                    const context = canvas.getContext('2d')
                    // 关闭抗锯齿 保证生成的分享图是清晰的
                    context.mozImageSmoothingEnabled = false
                    context.webkitImageSmoothingEnabled = false
                    context.msImageSmoothingEnabled = false
                    context.imageSmoothingEnabled = false
                    that.hideLoading()
                })
            }
            imgs.src = imgUrl
        },
        initBS () {
            this.$nextTick(() => {
                if (this.order.is_lotto && this.order.coupon) {
                    this.$refs.swipe.style.width = 'calc(100% + 8.533333rem)'
                    if (!this.BScroll) {
                        this.BScroll = new BScroll(this.$refs.swipeContainer, {
                            startX: 0,
                            click: true,
                            scrollX: true,
                            scrollY: false,
                            bounce: false,
                            eventPassthrough: 'vertical'
                        })
                    }
                }
            })
        }
    },
    destroyed () { }
}
